import { ClockCounterClockwise, Database, FolderOpen } from "@phosphor-icons/react";

const MainNavItems = ({
  sidenavCollapsed,
  isDocumentLibraryPage,
  viewChats,
  onDocumentLibraryClick,
  onChatHistoryClick,
  onMemoryClick,
}) => {
  const itemClass = "flex items-center gap-[8px] pl-[8px] pr-[8px] py-[12px] cursor-pointer rounded-[9999px] transition-colors hover:bg-[#EFE3D366]";
  const activeItemClass = "flex items-center gap-[8px] pl-[8px] pr-[8px] py-[12px] cursor-pointer rounded-[9999px] transition-colors hover:bg-[#EFE3D366]";
  const labelClass = "font-['DM_Sans'] font-medium text-[14px] leading-[100%] tracking-[0px]";

  return (
    <>
      <li
        data-testid="nav-chats"
        className={viewChats ? activeItemClass : itemClass}
        onClick={onChatHistoryClick}
      >
        <div className="w-[13px] h-[13px] shrink-0 flex items-center justify-center">
          <ClockCounterClockwise
            size={13}
            weight={viewChats ? "fill" : "bold"}
            className={viewChats ? "text-[#0F0F0F]" : "text-[#525252]"}
          />
        </div>
        {!sidenavCollapsed && (
          <p className={`${labelClass} ${viewChats ? "text-[#0F0F0F]" : "text-[#525252]"}`}>
            Chats
          </p>
        )}
      </li>

      <li
        data-testid="nav-document-library"
        className={isDocumentLibraryPage ? activeItemClass : itemClass}
        onClick={onDocumentLibraryClick}
      >
        <div className="w-[13px] h-[13px] shrink-0 flex items-center justify-center">
          <FolderOpen
            size={13}
            weight={isDocumentLibraryPage ? "fill" : "bold"}
            className={isDocumentLibraryPage ? "text-[#0F0F0F]" : "text-[#525252]"}
          />
        </div>
        {!sidenavCollapsed && (
          <p className={`${labelClass} ${isDocumentLibraryPage ? "text-[#0F0F0F]" : "text-[#525252]"}`}>
            Documents
          </p>
        )}
      </li>

      {!window.location.pathname.toLowerCase().includes("/shared/") && (
        <li
          data-testid="nav-profile-memory"
          className={itemClass}
          onClick={onMemoryClick}
        >
          <div className="w-[13px] h-[13px] shrink-0 flex items-center justify-center">
            <Database size={13} weight="bold" className="text-[#525252]" />
          </div>
          {!sidenavCollapsed && (
            <p className={`${labelClass} text-[#525252]`}>
              Memory
            </p>
          )}
        </li>
      )}
    </>
  );
};

export default MainNavItems;
